import React from 'react';

const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'About', href: '#about' },
  { name: 'Skills', href: '#skills' },
  { name: 'Projects', href: '#projects' },
  { name: 'Contact', href: '#contact' },
];

export default function Navbar({ onToggleTheme, darkMode }) {
  return (
    <nav className="sticky top-0 z-50 backdrop-blur-md bg-black/30 border-b border-white/10 shadow-md">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between h-16">
        <span className="text-xl font-semibold tracking-tight text-accent-primary font-poppins">
          Aniket Shukla
        </span>
        <ul className="flex gap-6 items-center">
          {navLinks.map(link => (
            <li key={link.name}>
              <a
                href={link.href}
                className="text-sm font-medium text-slate-300 hover:text-accent-secondary transition-colors duration-200"
              >
                {link.name}
              </a>
            </li>
          ))}
          <li>
            <button
              onClick={onToggleTheme}
              className="ml-4 p-2 rounded-full bg-slate-900/50 hover:bg-accent-secondary/30 transition duration-300 border border-white/10"
              aria-label="Toggle theme"
            >
              <span className="block w-[18px] h-[18px] bg-accent-primary rounded-full" />
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
